/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GoalType = {
    properties: {
        translation: {
            type: 'Translation',
            isRequired: true,
        },
        key: {
            type: 'GoalTypeEnum',
            isRequired: true,
        },
    },
} as const;
